import api from "./apiClient";
import { decodeBase64Json } from "../utils/decodeBase64Json";
export const getPartitionInfo = async () => {
    const response = await api.post("/DS/admin_center/get_partition_license_info.zjs");
    const base64 = response?.data?.[0]?.ResultBase64;

    const decoded = decodeBase64Json(base64);
    return decoded;
};

export const manageUser = async ({
    action,
    company_id = "",
    sys_user_id = "",
    username = "",
    password = "",
    user_email = "",
    access_child_agents = "",
    is_active = "",
}) => {
    const payload = {
        action,
        company_id,
        sys_user_id,
        username,
        password,
        user_email,
        access_child_agents,
        is_active,
    };

    const response = await api.post(
        "/DS/admin_center/user_management.zjs",
        payload
    );

    return response.data;
};
